import React, {createContext, useState, useContext, useEffect} from 'react';
import { apiCall } from "../helpers/ApiCalls";
import { SesionContext } from '../context/SesionContext';

export const ValidateContext = createContext();
export const ValidateProvider = ({children}) => {
  const { isAuth,cerrarSesion } = useContext(SesionContext);
  const [isValido, setValido] = useState(true);
  const [validando, setValidando] = useState(true);
  
  useEffect(()=>{
    
      if(isAuth){
      console.log("Si hay token");
      apiCall('GET','usuario/validar').then((res)=>{
        if(res.code === 401 || !res.success){
          cerrarSesion();
        }
        setValido(false);
        setValidando(false);
      });
    }else{
      console.log("No hay token");
        setValidando(false);
      
    }
  },[]);
  const value = {
    isValido,
    validando,
    setValido
  }
  return (
    <ValidateContext.Provider value = {value}>
      {children}
    </ValidateContext.Provider>
  );
}
